import { cart, pubsub } from '@services';
import { fetchHTML } from '@utils';

class QuickShop extends HTMLElement {
  #productId = this.dataset.productId;

  static {
    cart.sections.push('fetch-quick-shop');

    // When a product is added to the cart, close the quick shop dialog
    pubsub.subscribe('cart:add', ({ items }) => {
      pubsub.publish('dialog:close', { id: `quick-shop-dialog-${items[0].product_id}` });
    });
  }

  connectedCallback() {
    this.addEventListener('click', (event) => this.#handleClick(event));
  }

  /**
   * Handle click.
   */
  async #handleClick(event) {
    // if click is on not on the button, do not fetch
    if (!event.target.closest('[data-dialog-controller]')) return;
    if (!this.#productId) return;

    const target = document.querySelector(`#quick-shop-dialog-${this.#productId} .dialog__content`);

    // Do not fetch if there is content already fetched
    if (target.querySelector('#shopify-section-fetch-quick-shop')) return;

    try {
      const baseUrl = this.dataset.url;
      const separator = baseUrl.includes('?') ? '&' : '?';
      const url = `${baseUrl}${separator}section_id=fetch-quick-shop`;
      const html = await fetchHTML(url);
      target.innerHTML = html.getElementById('shopify-section-fetch-quick-shop').innerHTML;
    } catch (error) {
      console.error('Error fetching quick shop content:', error);
    }
  }
}

customElements.define('quick-shop', QuickShop);
